import axios from '@/utils/request.js'

export const companyList = (params) => { // 公司列表
  return axios.post('/goods/gas/company/companyList', params)
}

export const reportList = (params) => { // 举报列表
  return axios.post('/goods/gas/report/page', params)
}

export const employeeList = () => { // 人员列表
  return axios.post('/goods/gas/employee/tree', { companyId: '1407232924197171201' })
}

export const delCompany = (id) => { // 删除公司
  return axios.post(`/goods/gas/company/delete/${id}`)
}
export const getReportList = (params) => { // 举报列表2
  return axios.post('/goods/gas/report/getReportList', params)
}
export const getDetail = (id) => { //  查询举报信息明细
  return axios.post(`/goods/gas/report/getDetail/${id}`)
}
